import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert message
                    this.clear();
                }
            }
        });
    }

    get alert(): Observable<any> {
        return this.subject.asObservable();
    }

    private _alert(message: string, keepAfterRouteChange: boolean, type: string) {
        console.debug('alert', message);
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type, text: message });
    }

    success(message: string, keepAfterRouteChange = false) {
        this._alert(message, keepAfterRouteChange, 'success');
    }

    error(message: string, keepAfterRouteChange = false) {
        this._alert(message, keepAfterRouteChange, 'error');
    }

    warn(message: string, keepAfterRouteChange = false) {
        this._alert(message, keepAfterRouteChange, 'warn');
    }

    clear() {
        // clear by calling subject.next() without parameters
        this.subject.next(null);
    }
}